// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","wrapper":"UploadButton__wrapper--DF","input":"UploadButton__input--Mi","caption":"UploadButton__caption--N5","dragover":"UploadButton__dragover--iz"};